module.exports = __webpack_public_path__ + "static/img/image015.20721ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image015.png
// module id = vXzW
// module chunks = 1